<script setup>
import MenuLayout from '@/pages/layout/MenuLayout.vue'
import { Pane, Splitpanes } from 'splitpanes'
import { onUnmounted, reactive } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import 'splitpanes/dist/splitpanes.css'
import Vue3TreeVue from 'vue3-tree-vue'
import { useMetaStore } from '@/stores'
import { arrDepth, get, isDummyBbox, loadEpsgs, loadEpsgsWithPrjInit, openWin, post, qsel, senitizeLonLatBbox, toJson, validators, ymd } from '@/common/util'
import config from '@/common/config'
import _ from 'lodash-es'
import draggableComponent from 'vuedraggable'
import { transformExtent } from 'ol/proj'
import { getBottomLeft, getCenter, getHeight, getWidth } from 'ol/extent'
import TileLayer from 'ol/layer/Tile'
import { ImageWMS, TileWMS} from 'ol/source'
import ZoomSlider from 'ol/control/ZoomSlider'
import { Map, View } from 'ol'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import LayerGroup from 'ol/layer/Group'
import { VTextField } from 'vuetify/components/VTextField'
import MemPicker from '@/components/MemPicker.vue'
import DataDetail from '@/components/member/DataDetail.vue'
import Logs from '@/components/admin/config/Logs.vue'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON.js';
import WKT from 'ol/format/WKT.js';
import Modify from 'ol/interaction/Modify.js';
import Select from 'ol/interaction/Select.js';
import Draw from 'ol/interaction/Draw.js';
import Snap from 'ol/interaction/Snap.js';
import Translate from 'ol/interaction/Translate.js';
import {get as getProjection} from 'ol/proj.js';
import {Circle, Fill, Stroke, Style} from 'ol/style.js';
import { click } from 'ol/events/condition'
import MousePosition from 'ol/control/MousePosition.js';
import { createStringXY } from 'ol/coordinate'
import { toContext } from 'ol/render'
import { fromExtent } from 'ol/geom/Polygon'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { onMounted ,ref} from 'vue'
import ImageLayer from 'ol/layer/Image'
import BgMapSelector from '@/components/BgMapSelector.vue'
import Cookies from "js-cookie"
const route=useRoute(),router=useRouter(),metaStore=useMetaStore(),bgselector=ref(null)
const meta=reactive({showleft:true,showright:true,treeshown:true,groups:[],layers:[],data:[],maplayers:[],layerkinds:['vector','raster','api'],layertypes:['Point','LineString','Polygon'],isaddmode:true
  ,styleheads:[{tk:'preview'},{tk:'groupname',col:'groupid'},{tk:'name',col:'nm'},{tk:'registrationmodificationdate',col:'mdt'}],styles:{rows:[]},selstyle:'',inters:{},featureselected:false
  ,disableaddmode:false,fields:[],selfieldtype:'String',selfeaturetab:'prop',selfid:null,modifyfeature:{},modeditfeatures:{creates:[],dels:[],mods:[]},metalim:500,manfields:false})
,toList=()=>{
  router.push({path: '/admin/mandata/managelayers'})
},findItem=({id,islayer})=>{
  let item
  if(islayer)meta.data.forEach(group=>group.children.forEach(lyr=>{
    if(lyr.id==id)item=lyr
  }))
  else meta.data.forEach(group=>{
    if(group.id==id)item=group
  })
  return item
},saveStyle=async()=>{
  const pd={id:meta.sellayer.id}
  if(meta.selstyle==='true'||meta.selstyle==='false'||meta.selstyle===true||meta.selstyle===false)pd.style=null
  else pd.style=meta.selstyle
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/styletolayer',pd)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(!res.isSuccess)return
  meta.sellayer=res.data
  meta.selstyle=meta.sellayer.style
  meta.layers[meta.layers.findIndex(lyr=>lyr.id==meta.sellayer.id)]=toJson(meta.sellayer)
  initMapLayers()
  searchStyle()
},searchStyle=async(obj)=>{
  if(!meta.searchstylenm)meta.searchstylenm=''
  meta.styles={rows:[]}
  const spm={page:1,size:99999,isasc:false,sortcol:'mdt',where:{nm:meta.searchstylenm}}
  spm.fields=['id','nm','groupid','mdt','gsstylenms','styletype']
  spm.where.styletype_eq_=meta.selstyletype.replace('Multi','').replace('String','')
  if(meta.sellayer.layerkind=='raster')spm.where.styletype_eq_='Manual'
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/layerstyles',spm)
  metaStore.blockLoading(false)
  meta.selstyle=meta.sellayer.style
  meta.styles=res.data
},save=async ()=>{
  metaStore.blockLoading()
  const savemodel={isupdatelayer:true,isupdatevector:false,isupdateraster:false}
  savemodel.layer={...meta.sellayer}
  if(savemodel.layer.groupid=='defaultgroups')savemodel.layer.groupid=null
  savemodel.features=[]
  if(meta.onediting){
    if(meta.sellayer.layerkind=='vector'){
      savemodel.isupdatevector=true
      const wktFormat=new WKT()
      _.entries(meta.modeditfeatures).forEach(ent=>ent[1].forEach(feature=>{
        const savefeature={}
        savefeature.layerid=meta.sellayer.id
        savefeature.id=feature.getId()
        savefeature.layertype=feature.getGeometry().getType()
        savefeature.cdepth=arrDepth(feature.getGeometry().getCoordinates())
        savefeature.wkt=wktFormat.writeFeature(feature,{featureProjection:meta.map.getView().getProjection(),dataProjection:'EPSG:'+meta.sellayer.epsg})
        if(ent[0]=='creates')savefeature.cmdtype='create'
        if(ent[0]=='dels')savefeature.cmdtype='delete'
        if(ent[0]=='mods')savefeature.cmdtype='modify'
        savemodel.features.push(savefeature)
      }))
    }
    if(meta.sellayer.layerkind=='raster')savemodel.isupdateraster=true
  }
  const res=await post('rest/authed/admin/data/savelayer',savemodel)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(res.isSuccess)init(meta.sellayer.id)
},sub=async type=>{
  meta.subtype=null
  metaStore.pop({ison:false})
  modField()
  modFeature()
  meta.showsub=false
  meta.subttl=null
  if(type=='selstyle'){
    meta.subttl=metaStore.t('chooseastyle')
    meta.selstyletype=meta.sellayer.layertype.replace('Multi','').replace('String','')
    await searchStyle()
  }
  if(type=='metadata')meta.subttl=metaStore.t('metadata')
  if(type=='datadetail')meta.subttl=metaStore.t('datadetails')
  if(type=='log')meta.subttl=metaStore.t('viewinglayerlogs')
  if(type=='share'||type=='save')return metaStore.pop({ison:true,callback:()=>meta.subtype=type})
  meta.showsub=true
  if(!type||type=='manfields'||type=='featuredetail')meta.showsub=false
  if(type=='manfields'&&!meta.editlayer.getSource().getFeatures().length)return metaStore.toastKey('no_spitial_data',false)
  if(type!='featuredetail')clearSelFid()
  if(type=='featuredetail'){
    meta.selfeaturetab='prop'
  }
  meta.subtype=type
},getGeojson=async(layer,force,max=5000,bbox)=>{
  if(!force&&(!layer.gslayernm||meta.onediting||meta.selfid))return
  if(layer.layerkind!='vector')return
  //if(meta.totalFeatures&&meta.totalFeatures==meta.numberReturned)return
  metaStore.blockLoading()
  const wpm={
    service: "WFS",
    version: "1.0.0",
    request: "GetFeature",
    typeName: layer.gslayernm,
    maxFeatures: 1,
    outputFormat: "application/json",
    srsName:'EPSG:'+layer.epsg
  }
  if(meta.totalFeatures==null){
    const geojson=await get('wfs',()=>{},wpm)
    meta.totalFeatures=geojson.totalFeatures
  }
  wpm.maxFeatures=max
  if(!bbox||!bbox.length){
    bbox=meta.map.getView().calculateExtent()
  }
  //bbox=buffer(bbox,500)
  // if(meta.lastextent&&containsExtent(bbox,meta.lastextent)){
  //   metaStore.blockLoading(false)
  //   return
  // }
  meta.lastextent=bbox
  const calced=transformExtent(bbox,meta.map.getView().getProjection().getCode(),'EPSG:'+layer.epsg)
  wpm.bbox=calced.toString()
  const geojson=await get('wfs',()=>{},wpm)
  meta.numberMatched=geojson.numberMatched
  meta.numberReturned=geojson.numberReturned
  meta.editlayer.getSource().clear()
  meta.editlayer.getSource().addFeatures(new GeoJSON().readFeatures(geojson,{dataProjection:'EPSG:'+meta.sellayer.epsg,featureProjection: meta.map.getView().getProjection()}))
  metaStore.blockLoading(false)
},debounceGetGeojson=_.debounce(getGeojson,300)
,syncRasterExt=(toPolygon)=>{
  const poly=firstFeature()
  if(toPolygon){
    let coo=[meta.sellayer.minx,meta.sellayer.miny,meta.sellayer.maxx,meta.sellayer.maxy]
    coo=transformExtent(coo,'EPSG:'+meta.sellayer.epsg,meta.map.getView().getProjection())
    if(coo.some(num=>num==Infinity))return metaStore.toastKey('wrong_extent',false)
    coo=fromExtent(coo).getCoordinates()
    poly.getGeometry().setCoordinates(coo)
  }else{
    let ext=poly.getGeometry().getExtent()
    ext=transformExtent(ext,meta.map.getView().getProjection(),'EPSG:'+meta.sellayer.epsg)
    meta.sellayer.minx=parseFloat(ext[0].toFixed(4))
    meta.sellayer.miny=parseFloat(ext[1].toFixed(4))
    meta.sellayer.maxx=parseFloat(ext[2].toFixed(4))
    meta.sellayer.maxy=parseFloat(ext[3].toFixed(4))
  }
},modField=async flag=>{
  meta.modfieldtype=null
  if((flag=='delpop'||flag=='modpop')&&_.isEmpty(meta.selfieldnm))return metaStore.toastKey('sel_tar_con',false)
  if(flag=='del'){
    meta.fields.splice(meta.fields.findIndex(field=>field.name==meta.selfieldnm),1)
    flag=null
    return modField('save')
  }
  if(flag=='newpop'||flag=='modpop')meta.newfieldnm=flag=='modpop'?meta.selfieldnm:''
  if(flag=='mod'){
    if(meta.fields.some(field=>field.name==meta.newfieldnm)){
      flag='modpop'
      metaStore.toastKey('nm_already_taken',false)
    }else{
      flag=null
      meta.fields.find(field=>field.name==meta.selfieldnm).name=meta.newfieldnm
    }
  }
  if(flag=='new'){
    if(meta.fields.some(field=>field.name==meta.newfieldnm)){
      flag='newpop'
      metaStore.toastKey('nm_already_taken',false)
    }else{
      flag=null
      meta.fields.push({name:meta.newfieldnm,type:meta.selfieldtype})
      return modField('save')
    }
  }
  if(flag=='save'){
    metaStore.blockLoading()
    const pms={}
    meta.fields.forEach(field=>pms[field.name]=field.type)
    const res=await post('rest/authed/admin/data/modlayerfields/'+meta.sellayer.id,pms)
    metaStore.blockLoading(false)
    metaStore.toastKey('thesaveiscomplete')
    flag=null
    meta.manfields=true
    selTree(findItem({id:meta.sellayer.id,islayer:true}),true)
  }
  meta.modfieldtype=flag
  meta.fieldmodpop=meta.modfieldtype!=null
},clearSelFid=()=>{
  meta.selfid=null
  const radio=qsel('[name=selfid]:checked')
  if(radio)radio.checked=false
  meta.detaillayer.getSource().clear()
},firstFeature=()=>{
  return meta.editlayer.getSource().getFeatures()[0]??null
},modFeature=async flag=>{
  meta.modfeaturetype=null
  if(flag=='save'||flag=='del'){
    metaStore.blockLoading()
    const pd=toJson(meta.modifyfeature)
    _.entries(pd.attrs).forEach(ent=>pd.attrs[ent[0]]={type:meta.fields.find(field=>field.name==ent[0]).type,value:ent[1]})
    pd.refid=meta.sellayer.id
    pd.cmdtype=flag=='save'?'modify':'delete'
    if(flag=='del'){
      pd.attr=null
    }
    if(flag=='save'){
      const feature=meta.editlayer.getSource().getFeatureById(pd.id).clone()
      feature.getGeometry().setCoordinates(pd.coords)
      pd.wkt=new WKT().writeFeature(feature)
    }
    delete pd.coords
    const res=await post('rest/authed/admin/data/modifylayerfeatures',[pd])
    metaStore.toastRslt(res,flag=='save')
    metaStore.blockLoading(false)
    flag=null
    if(res.isSuccess){
      initMapLayers(true)
      selTree(findItem({id:meta.sellayer.id,islayer:true}),true)
      initMapLayers()
    }
  }
  meta.modfeaturetype=flag
  meta.featuremodpop=flag!=null
},actSelFid=id=>{
  if(id&&id==meta.selfid){
    meta.map.getView().setCenter(getCenter(meta.editlayer.getSource().getFeatureById(id).clone().getGeometry().getExtent()))
    return
  }
  clearSelFid()
  sub()
  meta.modifyfeature={attrs:{}}
  if(id==null)return
  const feature=meta.editlayer.getSource().getFeatureById(id).clone()
  meta.map.getView().setCenter(getCenter(feature.getGeometry().getExtent()))
  meta.selfid=id
  const radio=qsel('[value="'+id+'"]')
  radio.checked=true
  radio.scrollIntoView({block: 'center'})
  meta.disablemapevt=true
  meta.detaillayer.getSource().addFeature(feature.clone())
  meta.disablemapevt=false
  meta.fields.forEach(field=>{
    meta.modifyfeature.attrs[field.name]=feature.getProperties()[field.name]
    if(field.type=='Date'&&meta.modifyfeature.attrs[field.name])meta.modifyfeature.attrs[field.name]=new Date(feature.getProperties()[field.name])
  })
  feature.getGeometry().transform(meta.map.getView().getProjection(),'EPSG:'+meta.sellayer.epsg)
  meta.modifyfeature.id=id
  meta.modifyfeature.layertype=feature.getGeometry().getType()
  meta.modifyfeature.coords=feature.getGeometry().getCoordinates()
  meta.modifyfeature.cdepth=arrDepth(meta.modifyfeature.coords)
  get('rest/authed/member/featurelink/layer_detail/'+id,res=>{
    if(!res.data.id)return
    meta.modifyfeature.featurelink=res.data.url
  })
  get('rest/authed/member/featurelink/layer_svlink/'+id,res=>{
    if(!res.data.id)return
    meta.modifyfeature.svlink=res.data.url
  })
  sub('featuredetail')
},selTree=async (item,force)=>{
  if(!item.islayer)return
  if(force)meta.data.forEach(group=>group.children.forEach(lyr=>lyr.selected=false))
  if(item.islayer&&item.selected){
    meta.showdetail=true
    return
  }
  sub()
  clearSelFid()
  meta.lastextent=null
  meta.numberMatched=0
  meta.numberReturned=0
  meta.detaillayer.getSource().clear()
  meta.onediting=false
  item.checked=false
  let gid=meta.layers.find(lyr=>lyr.id==item.id).groupid
  if(!gid)gid='defaultgroups'
  findItem({id:item.id,islayer:true}).selected=true
  findItem({id:gid,islayer:false}).expanded=true
  meta.sellayer=meta.layers.find(lyr=>lyr.id==item.id)
  if(!meta.sellayer.groupid)meta.sellayer.groupid='defaultgroups'
  meta.data.forEach(group=>group.children.forEach(lyr=>lyr.disabled=false))
  meta.showdetail=true
  meta.fields=[]
  if(meta.sellayer.layerkind=='vector'){
    let fts=await get('rest/authed/admin/data/featuretypes/'+meta.sellayer.gsworkspace+'/'+meta.sellayer.gslayernm)
    meta.fields=fts.data.featureType.attributes.attribute
    if(Array.isArray(meta.fields))meta.fields=meta.fields.filter(ft=>ft.name!='geometry'&&ft.name!='the_geom'&&ft.name!='FID'&&ft.name!='ID'&&ft.name!='fid'&&ft.name!='id'&&ft.name!='etc')
    else meta.fields=[]
  }
  if(meta.sellayer.layerkind=='api'){
    meta.selapigroup=meta.apigroups.find(ag=>ag.id==meta.apis.find(api=>api.id==meta.sellayer.apiid).groupid)
  }
  meta.fields.forEach(field=>field.type=_.last(field.binding.split('.')))
  if(getProjection('EPSG:'+meta.sellayer.epsg)==null)metaStore.toastKey('not_register_epsg',false)
  treeCheck(item)
  meta.totalFeatures=null
  debounceGetGeojson(meta.sellayer)
  toggleEdit()
  if(meta.sellayer.layerkind=='vector'){
    debounceGetGeojson(meta.sellayer)
  }else if(meta.sellayer.layerkind=='raster'){
    let ext=await get('rest/authed/admin/data/coveragedetail/'+meta.sellayer.gsworkspace+'/'+meta.sellayer.gslayernm)
    ext=ext.data.nativeBoundingBox
    meta.sellayer.minx=parseFloat(ext.minx)
    meta.sellayer.miny=parseFloat(ext.miny)
    meta.sellayer.maxx=parseFloat(ext.maxx)
    meta.sellayer.maxy=parseFloat(ext.maxy)
    meta.rasterext=[meta.sellayer.minx,meta.sellayer.miny,meta.sellayer.maxx,meta.sellayer.maxy]
    const geojson= {
      'type': 'FeatureCollection',
      'crs': {
        'type': 'name',
        'properties': {
          'name': 'EPSG:'+meta.sellayer.epsg,
        },
      },
      'features': [{
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates":fromExtent(meta.rasterext).getCoordinates()
        }
      }]
    }
    meta.editlayer.getSource().clear()
    meta.editlayer.getSource().addFeatures(new GeoJSON().readFeatures(geojson,{dataProjection:'EPSG:'+meta.sellayer.epsg,featureProjection: meta.map.getView().getProjection()}))
  }
  const lyrnm='layer_'+item.id
  const bbox=meta.bboxes&&meta.bboxes[lyrnm]
  if(bbox&&!isDummyBbox(bbox)){
    meta.map.getView().fit(bbox,{padding:[100,100,100,100],callback:()=>{
      if(meta.map.getView().getZoom()>19)meta.map.getView().setZoom(19)
    }})
  }else metaStore.toast('해당 레이어의 영역정보가 없습니다.',false)
  if(meta.manfields){
    meta.manfields=false
    sub('manfields')
  }
},layerDragEnd=()=>{
  initMapLayers()
},reorderTreeLayer=async(item,isup)=>{
  const group = meta.data.find(gr => gr.id === item.groupid);
  if (!group || group.children.length < 2) return;
  const idx = group.children.findIndex(child => child.id === item.id);
  if (idx === -1) return;
  if (isup) {
    if (idx === 0) return;
    [group.children[idx - 1], group.children[idx]] = [group.children[idx], group.children[idx - 1]];
  } else {
    if (idx === group.children.length - 1) return;
    [group.children[idx], group.children[idx + 1]] = [group.children[idx + 1], group.children[idx]];
  }
  const orderingroup=[]
  group.children.forEach((lyr,idx)=>orderingroup.push({id:lyr.id,order:idx}))
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setlayerorders',orderingroup)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},treeCheck=item=>{
  const searched=findItem(item)
  const checked=!searched.checked
  if(!searched.islayer)searched.children.forEach(lyr=>lyr.checked=checked)
  searched.checked=checked
  meta.maplayers=[]
  meta.data.forEach(group=>group.children.forEach(lyr=>{
    if(lyr.checked||lyr.selected){
      lyr.checked=true
      meta.maplayers.push({nm:lyr.name,id:lyr.id,shown:true})
    }
  }))
  initMapLayers()
},shareSaved=async targettype=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setsharelayer',{id:meta.sellayer.id,sharetype:targettype})
  metaStore.blockLoading(false)
  meta.sellayer.sharetype=targettype
},filterLayer=txt=>{
  meta.data=toJson(meta.odata)
  const delids={}
  if(!_.isEmpty(txt))meta.data.forEach((group,gidx)=>group.children.forEach((lyr)=>{
    if(!lyr.name.toLowerCase().includes(txt.toLowerCase())){
      if(!delids[gidx])delids[gidx]=[]
      delids[gidx].push(lyr.id)
    }
  }))
  _.keys(delids).forEach(idx=>meta.data[idx].children=meta.data[idx].children.filter(lyr=>!delids[idx].includes(lyr.id)))
},findMapLayerById=(id)=>{
  let mlayer
  meta.layergroup.getLayers().forEach(lyr=>{
    if(lyr.get('layerid')==id)mlayer=lyr
  })
  return mlayer
},setVisible=(id,visible)=>{
  const mlayer=findMapLayerById(id)
  if(mlayer)mlayer.setVisible(visible)
},delFeature=()=>{
  meta.inters.sel.getFeatures().forEach(fea=>{
    meta.featureselected=false
    meta.editlayer.getSource().removeFeature(fea)
    let idx=meta.modeditfeatures.creates.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.creates.splice(idx,1)
    idx=meta.modeditfeatures.mods.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.mods.splice(idx,1)
    if(fea.getId()&&!meta.modeditfeatures.dels.includes(fea))meta.modeditfeatures.dels.push(fea)
  })
  meta.inters.sel.getFeatures().clear()
},setAddMode=()=>{
  meta.inters.sel.setActive(!meta.isaddmode)
  meta.inters.mod.setActive(!meta.isaddmode)
  meta.inters.trans.setActive(false)
  meta.inters.draw.setActive(meta.isaddmode)
  meta.inters.snap.setActive(false)
  meta.inters.sel.getFeatures().clear()
  if(meta.sellayer.layerkind=='raster')meta.inters.mod.setActive(false)
},toggleEdit=async()=>{
  if(meta.onediting)sub()
  if(meta.sellayer.layerkind=='raster'&&meta.rasterext){
    meta.sellayer.minx=meta.rasterext[0]
    meta.sellayer.miny=meta.rasterext[1]
    meta.sellayer.maxx=meta.rasterext[2]
    meta.sellayer.maxy=meta.rasterext[3]
  }
  meta.detaillayer.getSource().clear()
  meta.data.forEach(group=>group.children.forEach(item=>{
    item.disabled=meta.onediting
    if(item.selected)item.disabled=false
  }))
  setVisible(meta.sellayer.id,!meta.onediting)
  meta.featureselected=false
  _.keys(meta.inters).forEach(key=>{
    meta.map.removeInteraction(meta.inters[key])
    meta.inters[key]=null
  })
  meta.editlayer.setVisible(meta.onediting)
  meta.modeditfeatures={creates:[],dels:[],mods:[]}
  await getGeojson(meta.sellayer,true)
  if(!meta.onediting)return
  meta.inters.sel=new Select({condition:click,style:meta.sellayer.layerkind=='vector'?meta.vectorselstyle:meta.rasterstyle})
  meta.inters.sel.on('select',evt=>{
    meta.featureselected=meta.inters.sel.getFeatures().getArray().length>0
  })
  meta.inters.draw=new Draw({source:meta.editlayer.getSource(),type:meta.sellayer.layerkind=='raster'?'Polygon':meta.sellayer.layertype})
  meta.inters.draw.on('drawend',evt=>{
    meta.inters.sel.getFeatures().clear()
    evt.feature.set('created',true)
    meta.modeditfeatures.creates.push(evt.feature)
  })
  meta.inters.mod=new Modify({features: meta.inters.sel.getFeatures()})
  meta.inters.mod.on('modifyend',evt=>{
    evt.features.forEach(fea=>{
      if(fea.get('created'))return
      fea.set('modified',true)
      if(!meta.modeditfeatures.mods.includes(fea))meta.modeditfeatures.mods.push(fea)
    })
  })
  meta.inters.snap=new Snap({source:meta.editlayer.getSource()})
  meta.inters.trans = new Translate({features: meta.inters.sel.getFeatures()})
  meta.inters.trans.on('translateend',evt=>{
    evt.features.forEach(fea=>{
      if(fea.get('created'))return
      fea.set('modified',true)
      if(!meta.modeditfeatures.mods.includes(fea))meta.modeditfeatures.mods.push(fea)
    })
    if(meta.sellayer.layerkind=='raster')syncRasterExt(false)
  })
  _.keys(meta.inters).forEach(key=>meta.map.addInteraction(meta.inters[key]))
  meta.disableaddmode=false
  meta.isaddmode=true
  meta.editlayer.setStyle(meta.vectorstyle)
  if(meta.sellayer.layerkind=='raster'){
    meta.isaddmode=false
    meta.disableaddmode=true
    const rasterfeature=firstFeature()
    rasterfeature.set('raster',true)
    meta.editlayer.setStyle(meta.rasterstyle)
    meta.map.getView().fit(rasterfeature.getGeometry().getExtent(),{callback:()=>{
      const ext=firstFeature().getGeometry().getExtent()
      const pmin=meta.map.getPixelFromCoordinate([ext[0],ext[1]])
      const pmax=meta.map.getPixelFromCoordinate([ext[2],ext[3]])
      const pext=[pmin[0],pmin[1],pmax[0],pmax[1]]
      const width=Math.abs(getWidth(pext))
      const height=Math.abs(getHeight(pext))
      const img=new Image()
      img.onload=evt=>firstFeature().set('img',evt.target)
      img.crossOrigin = "Anonymous"
      img.src=config.backend+
      '/wms?service=WMS'+
      '&version=1.1.0'+
      '&request=GetMap'+
      '&layers='+encodeURIComponent(meta.sellayer.gslayernm)+
      '&bbox='+encodeURIComponent(ext.join(','))+
      '&width='+width.toFixed(0)+
      '&height='+height.toFixed(0)+
      '&srs='+encodeURIComponent(meta.map.getView().getProjection().getCode())+
      '&format=image%2Fpng&transparent=true'
    }})
  }
  setAddMode()
},toMapLayer=(item)=>{
  const layer=meta.layers.find(lyr=>lyr.id==item.id)
  let mlayer
  if(layer.layerkind=='api'){
    let url=new URL(layer.apiurl)
    url.search=''
    url=url.toString()
    const queries = new URLSearchParams(new URL(layer.apiurl).search)
    const params = {}
    queries.forEach((value, key) => params[key] = value)
    mlayer=new TileLayer({source:new TileWMS({url:url,params:params,visible:item.shown})})
  }else {
    if(!layer.gslayernm)return
    const params={LAYERS:layer.gslayernm}
    if(!_.isEmpty(layer.style))params.STYLES=layer.style
    mlayer=new ImageLayer({source:new ImageWMS({url:config.backend+'wms',params:params})})
    if(!_.isEmpty(layer.style)){
      mlayer.getSource().setImageLoadFunction((image, src) => {
        const resolution = meta.map.getView().getResolution();
        const meterRadius = 30 * resolution;
        image.getImage().src = src+`&env=layer:${layer.gsworkspace}:${layer.gslayernm};meter:${meterRadius}`;
      });
    }
    mlayer.getSource().on('imageloaderror', function (event) {
      metaStore.toast(`로드 에러:데이터/스타일을 확인해 주세요`,false)
    })
  }
  return mlayer
},initMapLayers=clear=>{
  meta.layergroup.getLayers().clear()
  if(clear)return
  meta.maplayers.toReversed().forEach(item=>{
    const maplayer=toMapLayer(item)
    if(maplayer){
      maplayer.set('layerid',item.id)
      maplayer.setVisible(item.shown)
      if(meta.onediting&&item.id==meta.sellayer.id)maplayer.setVisible(false)
      meta.layergroup.getLayers().push(maplayer)
    }
  })
},initMap=()=>{
  const layerGroup=new LayerGroup({layers:[]})
  meta.vectorstyle=(feature,res)=>{
    let color='rgba(90, 90, 90, 1.0)',fillcolor='rgba(200, 200, 200, 1.0)'
    if(feature.get('modified')){
      color='rgba(255, 140, 0, 1.0)'
      fillcolor='rgba(120, 60, 0, 1.0)'
    }
    if(feature.get('created')){
      color='rgba(255, 50, 50, 1.0)'
      fillcolor='rgba(150, 0, 0, 1.0)'
    }
    const fill=new Fill({color: fillcolor})
    const style=new Style({fill: fill,stroke: new Stroke({color: color,width: 3})})
    style.setImage(new Circle({fill:fill,stroke:style.getStroke(),radius:5}))
    return style
  }
  meta.rasterstyle=new Style({
    renderer: function (pixelCoordinates, state) {
      const context = state.context;
      const geometry = state.geometry.clone();
      geometry.setCoordinates(pixelCoordinates);
      const extent = geometry.getExtent();
      const width = getWidth(extent);
      const height = getHeight(extent);
      const img = state.feature.get('img');
      if (!img || height < 1 || width < 1) {
        return;
      }
      context.save();
      const renderContext = toContext(context, {
        pixelRatio: 1,
      })
      let color='rgba(90, 90, 90, 1.0)',fillcolor='rgba(0, 0, 0, 0)'
      if(meta.inters.sel.getFeatures().getLength())color='rgba(0, 30, 120, 1.0)'
      renderContext.setFillStrokeStyle(new Fill({color: fillcolor}),new Stroke({color: color,width: 3}))
      renderContext.drawGeometry(geometry)
      context.clip()
      const bottomLeft = getBottomLeft(extent)
      const left = bottomLeft[0]
      const bottom = bottomLeft[1]
      context.drawImage(img, left, bottom, width, height)
      context.restore()
    }
  })
  meta.vectorselstyle=(feature,res)=>{
    const fill=new Fill({color: 'rgba(0, 90, 255, 1.0)'}),stroke=new Stroke({color: 'rgba(255, 105, 180, 1.0)',width:5})
    return new Style({fill:fill,stroke:stroke,image:new Circle({fill:fill,stroke:stroke,radius:5})})
  }
  meta.editlayer=new VectorLayer({
    source:new VectorSource()
  })
  meta.detaillayer=new VectorLayer({
    source:new VectorSource(),style:meta.vectorselstyle
  })
  const basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  meta.map=new Map({layers:[basemapgroup,layerGroup,meta.detaillayer,meta.editlayer],target:'editmap'
    ,controls:defaultControls().extend([new ZoomSlider(),new MousePosition({projection:'EPSG:4326',coordinateFormat: createStringXY(4)})])
    ,view:new View()})
  meta.basemapgroup=basemapgroup
  let ext=[config.KoreaBbox.lonMin,config.KoreaBbox.latMin,config.KoreaBbox.lonMax,config.KoreaBbox.latMax]
  ext=transformExtent(ext,'EPSG:4326',meta.map.getView().getProjection())
  meta.map.getView().fit(ext)
  meta.map.getView().on('moveend',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.sellayer)
  })
  window.map=meta.map
  meta.map.getView().on('change:resolution',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.sellayer)
  })
  meta.map.getView().on('change:center',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.sellayer)
  })
  meta.map.on('singleclick',evt=>{
    if(meta.onediting||meta.sellayer.layerkind!='vector'||!meta.showdetail)return
    meta.editlayer.setOpacity(0)
    meta.editlayer.setVisible(true)
    meta.disablemapevt=true
    setTimeout((map,pixel) => {
      const features=map.getFeaturesAtPixel(pixel,{layerFilter:layer=>layer==meta.editlayer})
      meta.editlayer.setOpacity(1)
      meta.editlayer.setVisible(false)
      if(features.length)actSelFid(features[0].getId())
      else actSelFid()
      meta.disablemapevt=false
    }, 100,evt.map,evt.pixel)
  })
  meta.layergroup=layerGroup
},openManStyle=async()=>{
  openWin(config.frontRoot+'admin/mandata/managestyles')
},apis=async(needblock)=>{
  if(needblock)metaStore.blockLoading()
  const res=await get('rest/authed/admin/data/simpleextapis')
  if(needblock)metaStore.blockLoading(false)
  meta.apis=res.data.apis
  meta.apigroups=await get('rest/authed/member/groups/Externalapi')
  meta.apigroups=meta.apigroups.data
  meta.apigroups.unshift({id:null,nm:metaStore.t('defaultgroups')})
},init=async(id)=>{
  meta.treeshown=false
  metaStore.blockLoading()
  let res=await get('rest/authed/member/groups/Layer')
  meta.groups=_.sortBy(res.data.map(group=>({name:group.nm,id:group.id,gorder:group.gorder,children:[],selected:false,checked:false})),'gorder')
  res=await post('rest/authed/member/layers')
  meta.layers=_.sortBy(res.data,'order')
  meta.data=[...meta.groups]
  meta.data.unshift({name:metaStore.t('defaultgroups'),id:null,gorder:-1,children:[],selected:false,checked:false})
  meta.data.forEach(item=>item.disabled=true)
  meta.layers.forEach(lyr=>meta.data.find(group=>group.id==lyr.groupid)
    .children.push({name:lyr.nm,id:lyr.id,apiurl:lyr.apiurl,layerkind:lyr.layerkind,layertype:lyr.layertype,groupid:(lyr.groupid??'defaultgroups'),islayer:true,selected:false,checked:false}))
  meta.data[0].id='defaultgroups'
  meta.odata=toJson(meta.data)
  if(id)meta.sellayer=meta.layers.find(lyr=>lyr.id==route.params.id)
  await apis(false)
  loadEpsgsWithPrjInit(async epsgs=>{
    meta.epsgs=epsgs
    if(!meta.map)initMap()
    metaStore.blockLoading(false)
    fetch(config.backend+'wms?REQUEST=GetCapabilities').then(response => response.text()).then(str => {
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(str, 'application/xml')
      meta.bboxes={}
      xmlDoc.querySelector('Layer').querySelectorAll('Layer').forEach(lyrcapa=>{
        const ttl=lyrcapa.querySelector('Title').textContent
        if(!ttl.includes('layer_'))return
        let bbox=lyrcapa.querySelector('BoundingBox')
        const crs=bbox.getAttribute('CRS')
        const minx=bbox.getAttribute('minx')
        const miny=bbox.getAttribute('miny')
        const maxx=bbox.getAttribute('maxx')
        const maxy=bbox.getAttribute('maxy')
        if(crs.includes(':84')||crs.includes('4326'))bbox=senitizeLonLatBbox(minx,miny,maxx,maxy)
        else bbox=[minx,miny,maxx,maxy]
        if(bbox.some(a=>a=='-1.0E-4'))return
        bbox=transformExtent(bbox,crs,meta.map.getView().getProjection())
        if(bbox&&!bbox.toString().includes('Infinity')&&!bbox.some(pt=>pt==0))meta.bboxes[ttl]=bbox
      })
      meta.treeshown=true
      if(meta.sellayer)selTree(findItem({id:meta.sellayer.id,islayer:true}))
    })
  })
}
onMounted(()=>{
  Cookies.set('admdatamenu','managelayers')
  init(route.params.id)
})
onUnmounted(()=>{
  if(!meta.map)meta.map.setTarget(null)
})
</script>
<template>
  <MenuLayout>
    <div class="editlayer">
      <div v-if="meta.showleft" class="editlayer_left">
        <v-card flat class="me-2">
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="2"><v-btn variant="text" density="compact" icon="mdi-arrow-left" @click="toList"/></v-col>
              <v-col>{{$t('layerlist')}}</v-col>
            </v-row>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-1">
            <Splitpanes horizontal class="default-theme">
              <Pane size="60">
                <v-text-field hide-details clearable variant="outlined" density="compact" class="mt-3 mb-2" :label="$t('layername')" :placeholder="$t('enteralayername')" @update:model-value="filterLayer"/>
                <Vue3TreeVue v-if="meta.treeshown" class="editlayertree" :items="meta.data" @onSelect="selTree">
                  <template #item-prepend-icon="item">
                    <v-icon v-if="!item.islayer" icon="mdi-folder"/>
                    <v-icon v-else-if="item.layerkind=='raster'" icon="mdi-image-area"/>
                    <v-icon v-else-if="item.layerkind=='api'" icon="mdi-api"/>
                    <v-icon v-else-if="item.layerkind=='vector'&&item.layertype.includes('Point')" icon="mdi-vector-point"/>
                    <v-icon v-else-if="item.layerkind=='vector'&&item.layertype.includes('Line')" icon="mdi-vector-line"/>
                    <v-icon v-else-if="item.layerkind=='vector'&&item.layertype.includes('Polygon')" icon="mdi-vector-polygon"/>
                  </template>
                  <template #item-prepend="item">
                    <v-checkbox hide-details density="compact" width="25" :model-value="item.checked" :disabled="item.selected" @click.stop="treeCheck(item)"/>
                  </template>
                  <template #item-append="item">
                    <div v-if="item.islayer" class="flex-grow-1 text-right" style="width: 80px;">
                      <v-btn icon="mdi-arrow-up-bold" size="x-small" variant="text" color="primary" @click.stop="reorderTreeLayer(item,true)"/>
                      <v-btn icon="mdi-arrow-down-bold" size="x-small" variant="text" color="secondary" @click.stop="reorderTreeLayer(item,false)"/>
                    </div>
                  </template>
                </Vue3TreeVue>
              </Pane>
              <Pane v-if="meta.selbgmid" size="40" style="overflow-y: auto;">
                <p class="text-center pt-2 pb-2 bg-purple-darken-2">{{ $t('layervieworder') }}</p>
                <v-divider/>
                <draggableComponent v-model="meta.maplayers" item-key="id" @end="layerDragEnd">
                  <template #item="{element}">
                    <v-alert block border="start" density="compact" :icon="element.shown?'mdi-eye-outline':'mdi-eye-off-outline'" class="ma-1 cursor-pointer" :text="element.nm" @click="evt=>{
                      element.shown=!element.shown
                      setVisible(element.id,element.shown)
                    }"/>
                  </template>
                </draggableComponent>
                <v-alert block border="start" color="info" density="compact" class="ma-1 cursor-pointer" :text=" $t('backgroundmap')"
                  :icon="meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible())?'mdi-eye-outline':'mdi-eye-off-outline'"
                  @click="()=>{
                    if(meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible()))bgselector.hideAll()
                    else bgselector.selBgMap(meta.selbgmid)
                  }"/>
              </Pane>
            </Splitpanes>
          </v-card-text>
        </v-card>
      </div>
      <div class="editlayer_right">
        <div class="bgselwrap">
          <BgMapSelector ref="bgselector" :map="meta.map" width="100%" :onLoad="(bgms)=>meta.bgms=bgms" :onUpdate="bid=>meta.selbgmid=bid"/>
        </div>
        <div id="editmap" class="w-100 h-100" :style="'border: 4px solid '+(meta.onediting?'red':'white')+';'"/>
        <v-switch v-if="meta.onediting" hide-details density="compact" color="error" style="position: absolute;top:0px;right: 40px;z-index: 10;" v-model="meta.isaddmode" :disabled="meta.disableaddmode" @update:model-value="setAddMode">
          <template #prepend>
            <label>{{ $t('modify') }}</label>
          </template>
          <template #append>
            <label>{{ $t('new') }}</label>
          </template>
        </v-switch>
        <v-card v-if="meta.onediting" position="absolute" class="pa-2" width="120" style="top:40px;right: 40px;z-index: 10;font-size: 12px;">
          <div><v-icon icon="mdi-circle" style="color: rgba(255, 50, 50, 1.0);"/>{{ $t('new') }}</div>
          <div><v-icon icon="mdi-circle" style="color: rgba(0, 90, 255, 1.0);"/>{{ $t('selection') }}</div>
          <div><v-icon icon="mdi-circle" style="color: rgba(255, 140, 0, 1.0);"/>{{ $t('modify') }}</div>
        </v-card>
        <v-btn v-if="meta.sellayer?.layerkind=='vector'&&meta.featureselected" density="compact" color="error" position="absolute" style="top:120px;right: 40px;width: 120px;;z-index: 10;" :text="$t('delete')" @click="delFeature"/>
        <v-icon :icon="'mdi-chevron-'+(meta.showleft?'left':'right')" class="editlayer_left_tglbtn" @click="meta.showleft=!meta.showleft"/>
        <v-card v-if="meta.showdetail" position="absolute" width="350px" class="editlayer_detail">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('layer_detail_edit') }}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="meta.showdetail=false;sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pt-3" style="height: calc(100% - 100px);overflow-y: auto;">
            <v-defaults-provider :defaults="{VSelect:{hideDetails:true,variant:'outlined',density:'compact'},VTextField:{variant:'outlined',density:'compact'}}">
              <v-row no-gutters class="mb-4">
                <v-col>
                  <v-select :disabled="meta.onediting" :items="meta.data" v-model="meta.sellayer.groupid" :label="$t('layergroups')" :item-props="item=>({title:item.name,value:item.id})"/>
                </v-col>
                <!-- <v-col cols="3" class="text-right">
                  <v-btn :disabled="meta.onediting" variant="outlined" size="40" :prepend-icon="meta.sellayer.etc===null?'mdi-plus':'mdi-minus'" @click="meta.sellayer.etc=meta.sellayer.etc!=null?null:''"/>
                </v-col> -->
              </v-row>
              <v-row no-gutters v-if="meta.sellayer.etc!=null">
                <v-col><v-text-field :disabled="meta.onediting" :label="$t('newgroupname')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.sellayer.etc"/></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col><v-text-field :disabled="meta.onediting" :label="$t('layername')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.sellayer.nm"/></v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col>
                  <v-select :disabled="true" :label="$t('layerkind')" :model-value="$t(meta.sellayer.layerkind)" :items="meta.layerkinds.map($t)"/>
                </v-col>
                <v-col v-if="meta.sellayer.layerkind=='vector'">
                  <v-select :disabled="true" :label="$t('layertype')" :model-value="$t(meta.sellayer.layertype.replace('Multi',''))" :items="meta.layertypes.map($t)"/>
                </v-col>
              </v-row>
              <v-row v-if="meta.sellayer.layerkind!='api'">
                <v-col>
                  <v-select :disabled="true" class="mb-4" :items="meta.epsgs" v-model="meta.sellayer.epsg" :label="$t('coordinatesystem')" :item-props="item=>({title:'EPSG:'+item,value:item})"/>
                </v-col>
                <v-col>
                  <v-select :disabled="true" :items="['UTF-8']" v-model="meta.sellayer.encoding" :label="$t('encodingtype')"/>
                </v-col>
              </v-row>
              <div v-if="meta.sellayer.layerkind=='raster'&&meta.onediting" class="rastercoords">
                <p>{{ $t('aboutreferencecoordinates') }}</p>
                <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
                  <v-row>
                    <v-col class="ma-2"><v-number-input inset hide-details :step="0.00001" :precision="5" :label="'Min X'+$t('coordinates')" v-model="meta.sellayer.minx" @update:model-value="syncRasterExt(true)"/></v-col>
                    <v-col class="ma-2"><v-number-input inset hide-details :step="0.00001" :precision="5" :label="'Min Y'+$t('coordinates')" v-model="meta.sellayer.miny" @update:model-value="syncRasterExt(true)"/></v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col class="ma-2"><v-number-input inset hide-details :step="0.00001" :precision="5" :label="'Max X'+$t('coordinates')" v-model="meta.sellayer.maxx" @update:model-value="syncRasterExt(true)"/></v-col>
                    <v-col class="ma-2"><v-number-input inset hide-details :step="0.00001" :precision="5" :label="'Max Y'+$t('coordinates')" v-model="meta.sellayer.maxy" @update:model-value="syncRasterExt(true)"/></v-col>
                  </v-row>
                </v-defaults-provider>
              </div>
              <div v-if="meta.sellayer.layerkind!='api'">
                <p>{{ $t('managingstylesfieldinformation') }}</p>
                <v-row>
                  <v-col>
                    <v-btn :disabled="meta.onediting" block prepend-icon="mdi-map-marker-check-outline" :text="$t('chooseastyle')" @click="sub('selstyle')"/>
                  </v-col>
                  <v-col v-if="meta.sellayer.layerkind=='vector'">
                    <v-btn :disabled="meta.onediting" block :text="$t('managingpropertyfields')" @click="sub('manfields')"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="meta.sellayer.layerkind=='vector'" align-self="center">{{ $t('itemlist') }} <span v-if="meta.totalFeatures!=null">({{meta.numberReturned}}/{{meta.totalFeatures}})</span></v-col>
                  <v-col v-if="!(meta.sellayer.layerkind=='raster'&&!meta.sellayer.rastereditable)"><v-switch hide-details color="primary" :label="$t('mapeditmode')" v-model="meta.onediting" @update:model-value="toggleEdit"/></v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col>
                    <v-select hide-details :label="'API'+$t('groupname')" v-model="meta.selapigroup" :items="meta.apigroups" item-title="nm" item-value="id"/>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col>
                    <v-select hide-details :label="'API'+$t('name')" :items="meta.apis" item-title="ttl" item-value="id"
                      v-model="meta.sellayer.apiid" @update:model-value="val=>meta.sellayer.apiurl=meta.apis.find(api=>api.id==val).url"/>
                  </v-col>
                </v-row>
                <v-textarea variant="outlined" density="compact" class="mt-4" rows="15" label="API URL" v-model="meta.sellayer.apiurl" :rules="[validators.required]"/>
                <v-btn block density="compact" color="secondary" :text="'URL '+$t('initialize')" @click="()=>{
                  meta.sellayer.apiid=null
                  meta.sellayer.apiurl=findItem({id:meta.sellayer.id,islayer:true}).apiurl
                }"/>
              </div>
              <v-card v-if="meta.sellayer.layerkind=='vector'&&!meta.onediting&&meta.editlayer" flat>
                <div class="edititemtbl">
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>No.</th>
                        <th>TYPE</th>
                        <th>ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in meta.editlayer.getSource().getFeatures().map((fea,idx)=>({no:idx+1,type:meta.sellayer.layertype.replace('Multi',''),id:fea.getId()}))" @click="actSelFid(row.id)">
                        <td><input type="radio" name="selfid" :value="row.id" :checked="row.id==meta.selfid"/></td>
                        <td>{{ row.no }}</td>
                        <td>{{ $t(row.type) }}</td>
                        <td>{{ row.id }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <v-overlay contained :persistent="true" :model-value="meta.sellayer.layerkind!='vector'"/>
              </v-card>
              <p>{{ $t('layersharingdatadetails') }}</p>
              <v-row>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('managelayersharing')" @click="sub('share')"/>
                </v-col>
                <v-col v-if="meta.sellayer.layerkind=='vector'">
                  <v-btn :disabled="meta.onediting" block :text="$t('datadetails')" @click="sub('datadetail')"/>
                </v-col>
              </v-row>
              <p>{{ $t('showlog_metadata') }}</p>
              <v-row>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('viewinglayerlogs')" @click="sub('log')"/>
                </v-col>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('metadata')" @click="sub('metadata')"/>
                </v-col>
              </v-row>
            </v-defaults-provider>
          </v-card-text>
          <v-card-actions style="position: absolute;left: 0;right: 0;bottom: 0;">
            <v-row>
              <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="meta.showdetail=false"/></v-col>
              <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="sub('save')"/></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-card v-if="meta.showdetail&&meta.subtype=='featuredetail'" position="absolute" width="350px" class="editlayer_featuredetail">
          <v-card-title>
            <v-row>
              <v-col>{{$t('details')}}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-tabs v-model="meta.selfeaturetab" align-tabs="center" grow>
              <v-tab v-for="type in ['prop','coords']" :value="type">{{ $t(type=='prop'?'aboutpropertyfields':'coordinateinformation') }}</v-tab>
            </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="meta.selfeaturetab">
                <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact'}}">
                  <v-tabs-window-item value="prop" class="pt-2">
                    <v-row><v-col>
                        <v-text-field label="ID" v-model="meta.selfid" disabled/>
                    </v-col></v-row>
                    <v-textarea class="mt-3 mb-3" label="상세보기 링크" v-model="meta.modifyfeature.featurelink"/>
                    <v-textarea class="mt-3 mb-3" label="거리뷰 링크" v-model="meta.modifyfeature.svlink"/>
                    <v-row v-for="field in meta.fields">
                      <v-col>
                        <v-text-field v-if="field.type=='String'" :label="field.name" v-model="meta.modifyfeature.attrs[field.name]" :disabled="['featureid'].includes(field.name)"/>
                        <v-number-input inset aria-hidden="false" v-if="field.type=='Integer'||field.type=='Long'" :precision="0" :label="field.name" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-number-input inset aria-hidden="false" v-if="field.type=='Double'" :precision="5" :label="field.name" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-checkbox v-if="field.type=='Boolean'" :label="field.name" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-date-input v-if="field.type=='Date'" prepend-icon="" prepend-inner-icon="mdi-calendar" :label="field.name" v-model="meta.modifyfeature.attrs[field.name]"/>
                      </v-col>
                    </v-row>
                  </v-tabs-window-item>
                  <v-tabs-window-item v-if="meta.modifyfeature.layertype" value="coords" class="pt-2">
                    <v-alert v-if="meta.modifyfeature.layertype.includes('Multi')" v-for="(coords,idx) in meta.modifyfeature.coords" class="ma-1">
                      <p class="text-center">{{ idx+1 }}</p>
                      <table v-if="meta.modifyfeature.layertype.includes('Line')">
                          <thead>
                            <tr>
                              <th>{{ $t('xcoordinate') }}</th>
                              <th>{{ $t('ycoordinate') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(subcoords,subidx) in coords">
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][0]"/></td>
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][1]"/></td>
                            </tr>
                          </tbody>
                        </table>
                      <v-alert v-if="meta.modifyfeature.layertype.includes('Polygon')" v-for="(subcoords,subidx) in coords">
                        <table>
                          <thead>
                            <tr>
                              <th>{{ $t('xcoordinate') }}</th>
                              <th>{{ $t('ycoordinate') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(incoords,inidx) in subcoords">
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][inidx][0]"/></td>
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][inidx][1]"/></td>
                            </tr>
                          </tbody>
                        </table>
                      </v-alert>
                    </v-alert>
                    <div v-else>
                      <v-row v-if="meta.modifyfeature.layertype.includes('Point')">
                        <v-col><v-number-input :label="$t('xcoordinate')" :precision="5" v-model="meta.modifyfeature.coords[0]"/></v-col>
                        <v-col><v-number-input :label="$t('ycoordinate')" :precision="5" v-model="meta.modifyfeature.coords[1]"/></v-col>
                      </v-row>
                      <v-row v-if="meta.modifyfeature.layertype.includes('Line')" v-for="(subcoords,subidx) in coords">
                        <v-col><v-number-input :label="$t('xcoordinate')" :precision="5" v-model="meta.modifyfeature.coords[0][subidx][0]"/></v-col>
                        <v-col><v-number-input :label="$t('ycoordinate')" :precision="5" v-model="meta.modifyfeature.coords[1][subidx][1]"/></v-col>
                      </v-row>
                    </div>
                  </v-tabs-window-item>
                </v-defaults-provider>
              </v-tabs-window>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="3"><v-btn block :text="$t('cancel')" variant="elevated" @click="sub()"/></v-col>
              <v-col cols="3"><v-btn block :text="$t('delete')" color="error" variant="elevated" @click="modFeature('delpop')"/></v-col>
              <v-col><v-btn block :text="$t('save')" variant="elevated" color="primary" @click="modFeature('savepop')"/></v-col>
            </v-row>
          </v-card-actions>
          <v-overlay contained class="align-center justify-center" v-model="meta.featuremodpop">
            <ConfirmCard v-if="meta.modfeaturetype=='delpop'||meta.modfeaturetype=='savepop'" :ttl="$t('aboutpropertyfields')" :cont="meta.modfeaturetype.replace('pop','')" :min-width="300"
             @cancel="modFeature()" @confirm="modFeature(meta.modfeaturetype.replace('pop',''))"/>
          </v-overlay>
        </v-card>
        <v-card v-if="meta.showdetail&&meta.subtype=='manfields'" position="absolute" width="350px" class="editlayer_manfields">
          <v-card-title>
            <v-row>
              <v-col>{{$t('managingpropertyfields')}}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-defaults-provider :defaults="{VBtn:{density:'compact',block:true}}">
            <v-row no-gutters class="pa-2">
              <v-col class="pe-1"><v-btn color="error" :text="$t('delete')" @click="modField('delpop')"/></v-col>
              <!-- <v-col class="pe-1"><v-btn :text="$t('modify')" @click="modField('modpop')"/></v-col> -->
              <v-col class="pe-1"><v-btn color="info" :text="$t('new')" @click="modField('newpop')"/></v-col>
              <!-- <v-col><v-btn color="primary" :text="$t('save')" @click="modField('savepop')"/></v-col> -->
            </v-row>
          </v-defaults-provider>
          <p class="ma-2">{{ $t('attr_field_list') }}</p>
          <div class="fieldwrap">
            <draggableComponent v-model="meta.fields" item-key="name">
              <template #item="{element}">
                <v-checkbox hide-details :label="`${element.name}[${element.type}]`" :value="element.name" v-model="meta.selfieldnm"/>
              </template>
            </draggableComponent>
          </div>
          <v-overlay contained class="align-center justify-center" v-model="meta.fieldmodpop">
            <ConfirmCard v-if="meta.modfieldtype=='delpop'||meta.modfieldtype=='savepop'" :ttl="$t('managingpropertyfields')" :cont="meta.modfieldtype.replace('pop','')" :min-width="300"
             @cancel="modField()" @confirm="modField(meta.modfieldtype.replace('pop',''))"/>
            <v-card v-if="meta.modfieldtype=='modpop'||meta.modfieldtype=='newpop'" class="mx-auto" width="300" :title="$t('managingpropertyfields')">
              <v-divider/>
              <v-card-text>
                <v-text-field variant="outlined" density="compact" :label="$t('propertyfieldnames')" v-model="meta.newfieldnm"/>
                <v-select variant="outlined" density="compact" :label="$t('selectatype')" :items="['String','Integer']" v-model="meta.selfieldtype"/>
                <v-select :disabled="true" variant="outlined" density="compact" :label="$t('characterlimit')" :items="['127']" model-value="127"/>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-row justify="end">
                  <v-btn :text="$t('cancel')" variant="outlined" @click.stop="modField()"/>
                  <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="modField(meta.modfieldtype.replace('pop',''))" :disabled="_.isEmpty(meta.newfieldnm)"/>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-overlay>
        </v-card>
        <v-card v-if="meta.showsub&&meta.showdetail" style="position: absolute;bottom: 4px;right: 5px;z-index: 10;width: calc(100% - 355px);height: 500px;">
          <v-card-title>
            <v-row>
              <v-col>{{ meta.subttl }}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="meta.showsub=false"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text style="height: 450px;">
            <div v-if="meta.subtype=='selstyle'">
              <v-row>
                <v-col>
                  <v-tabs v-model="meta.selstyletype">
                    <v-tab v-for="type in meta.sellayer.layerkind=='api'?['Manual']:[meta.sellayer.layertype.replace('Multi',''),'Manual']" :value="type" @click="searchStyle">
                      {{ $t(type=='Manual'?'sldstylefiles':type) }}
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn :text="$t('managestyles')+' '+$t('shortcuts')" @click="openManStyle"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field hide-details variant="outlined" density="compact" :label="$t('stylename')" :placeholder="$t('enteranameforyourstyle')" v-model="meta.searchstylenm" @keyup.enter="searchStyle"/>
                </v-col>
                <v-col cols="1"><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="searchStyle"/></v-col>
                <v-col class="text-right">
                  <v-btn class="me-3" :text="$t('refresh')" @click="searchStyle"/>
                  <v-btn color="primary" :text="$t('applying')" @click="saveStyle"/>
                </v-col>
              </v-row>
              <v-table class="editstyletbl" height="320">
                <thead>
                  <tr>
                    <th style="width: 20px;"></th>
                    <th v-for="head in meta.styleheads">{{ $t(head.tk) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!meta.styles.rows.length"><td :colspan="meta.styleheads.length+1" class="text-center">{{ $t('noresultsfound') }}</td></tr>
                  <tr v-else v-for="row in meta.styles.rows">
                    <td><v-checkbox hide-details density="compact" :value="row.gsstylenms" v-model="meta.selstyle"/></td>
                    <td v-for="head in meta.styleheads" class="text-center">
                      <img v-if="head.tk=='preview'" style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id"/>
                      <div v-else-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                      <div v-else-if="head.col=='groupid'">{{ row.groupid?meta.styles.subrows.groups.find(group=>group.id==row.groupid).nm:$t('defaultgroups') }}</div>
                      <div v-else>{{ row[head.col] }}</div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </div>
            <div v-if="meta.subtype=='metadata'">
              <v-defaults-provider :defaults="{VTextField:{variant:'outlined',density:'compact',hideDetails:true,placeholder:$t('enteradescriptionupto500characters')}
                ,VTextarea:{variant:'outlined',density:'compact',hideDetails:true,placeholder:$t('enteradescriptionupto500characters')}}">
                <v-table class="editmetatbl">
                  <tbody>
                    <tr>
                      <th>{{ $t('metanm') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.sellayer.metanm" @keyup="()=>{
                        if(meta.sellayer.metanm.length>meta.metalim)meta.sellayer.metanm=meta.sellayer.metanm.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metatype') }}</th>
                      <td><v-text-field v-model="meta.sellayer.metatype" @keyup="()=>{
                        if(meta.sellayer.metatype.length>meta.metalim)meta.sellayer.metatype=meta.sellayer.metatype.substring(0,meta.metalim)
                      }"/></td>
                      <th>{{ $t('metaformat') }}</th>
                      <td><v-text-field v-model="meta.sellayer.metaformat" @keyup="()=>{
                        if(meta.sellayer.metaformat.length>meta.metalim)meta.sellayer.metaformat=meta.sellayer.metaformat.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metacrs') }}</th>
                      <td><v-text-field v-model="meta.sellayer.metacrs" @keyup="()=>{
                        if(meta.sellayer.metacrs.length>meta.metalim)meta.sellayer.metacrs=meta.sellayer.metacrs.substring(0,meta.metalim)
                      }"/></td>
                      <th>{{ $t('metamodinterval') }}</th>
                      <td><v-text-field v-model="meta.sellayer.metamodinterval" @keyup="()=>{
                        if(meta.sellayer.metamodinterval.length>meta.metalim)meta.sellayer.metamodinterval=meta.sellayer.metamodinterval.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaarea') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.sellayer.metaarea" @keyup="()=>{
                        if(meta.sellayer.metaarea.length>meta.metalim)meta.sellayer.metaarea=meta.sellayer.metaarea.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaorg') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.sellayer.metaorg" @keyup="()=>{
                        if(meta.sellayer.metaorg.length>meta.metalim)meta.sellayer.metaorg=meta.sellayer.metaorg.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metamethod') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.sellayer.metamethod" @keyup="()=>{
                        if(meta.sellayer.metamethod.length>meta.metalim)meta.sellayer.metamethod=meta.sellayer.metamethod.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('memo') }}</th>
                      <td colspan="3"><v-textarea class="mt-1 mb-1" rows="3" v-model="meta.sellayer.metamemo" @keyup="()=>{
                        if(meta.sellayer.metamemo.length>meta.metalim)meta.sellayer.metamemo=meta.sellayer.metamemo.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </div>
            <DataDetail v-if="meta.subtype=='datadetail'" :id="meta.sellayer.id" type="layer" tblheight="210"/>
            <Logs v-if="meta.subtype=='log'" :ispop="true" logcate="Layer" :targetid="meta.sellayer.id" :hideclose="true"/>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </MenuLayout>
  <Teleport v-if="meta.subtype=='share'" to="#popbody">
    <MemPicker tkey="sharinglayers" refnm="layer" :refid="meta.sellayer.id" auth="ADMIN,MEMBER" :targettypes="['all','partial']" :targettype="meta.sellayer.sharetype" @close-pop="sub()" @save-callback="shareSaved"/>
  </Teleport>
  <Teleport v-if="meta.subtype=='save'" to="#popbody">
    <ConfirmCard :ttl="$t('savelayer')" cont="save" @cancel="sub()" @confirm="save"/>
  </Teleport>
</template>
<style>
.editlayer{display: flex;flex-wrap: nowrap;height: 100%;}
.editlayer_left{width: 350px;}
.editlayer_left > .v-card{height: calc(100% - 10px);margin: 5px 0 5px 2px;}
.editlayer_left_tglbtn{cursor: pointer;position: absolute;color:#fff;background-color: #3F51B5;width: 20px;height: 82px;top:0;left: 0;z-index: 9;}
.editlayer .bgselwrap{position: absolute;z-index: 999;top: 6px;left: 28px;width: 322px;}
.editlayer_right{flex-grow: 1;position: relative;}
.editlayer .splitpanes{height: calc(100vh - 90px);}
.editlayer .splitpanes__pane{background-color: #fff !important;overflow-y: auto;}
.editlayer .splitpanes__splitter {min-height: 12px !important;}
#editmap{position: relative;z-index: 1;}
#editmap .ol-zoom{left: auto;right: 5px;}
#editmap .ol-zoomslider{left: auto;right: 5px;}
.editlayer_detail{top: 82px;left: 0;z-index: 10;height: calc(100% - 86px);}
.editlayer_detail p{margin: 10px 0 10px 0;}
.edititemtbl{border: 1px solid #797979;overflow-y: auto;height: 400px;}
.edititemtbl table{border-collapse: collapse;min-width: 100%;}
.edititemtbl th{height: 30px !important;text-align: center !important;background-color: #f2f2f2 !important;border-collapse: collapse;border: 1px solid #e0e0e0;}
.edititemtbl td{white-space: nowrap;text-align: center;border: 1px solid #e0e0e0;padding: 5px;cursor: pointer;}
.edititemtbl tr:has(:checked){background-color: #E8EAF6;}
.editstyletbl,.editmetatbl{border: 1px solid #e0e0e0;margin-top: 10px;}
.editstyletbl th{height: 40px !important;background-color: #eee !important;text-align: center !important; width: 180px;}
.editmetatbl th{width: 130px;background-color: #f2f2f2;}
.vue3-tree-vue span{user-select: none;}
.ol-attribution{display: none;}
.ol-mouse-position{top:auto;bottom: 0;}
.editlayer_manfields{top: 56px;left: 350px;z-index: 10;height: calc(100% - 60px);}
.editlayer_manfields .fieldwrap{border: 1px solid #ddd;margin: 8px;height: calc(100% - 140px);overflow: auto;}
.editlayer_featuredetail{top: 56px;right: 36px;z-index: 10;height: calc(100% - 320px);}
.editlayer_featuredetail .v-card-text{height: calc(100% - 150px);overflow-y: auto;}
.editlayer_featuredetail .v-number-input__control button{border-width: 0 !important;}
.editlayer .tree-item-node-parent{width: 100%;}
.editlayertree .tree-item .d-flex > span{width: 150px;}
</style>
